const APIS = {
  RUNSHEET: "/runsheetservice/api/runsheet/",
  BRANCH: "/logisticservice/api/branch/",
  DRIVER: "/fleetservice/api/driver/",
  VEHICLE: "fleetservice/api/vehicle/",
  RUNSHEET_ITEMS: "/runsheetservice/api/runsheet-item/",
  DRIVER_CREATE: "/fleetservice/api/driver/create-rider/",
  STATUS: "/logisticservice/api/status/",
  MERCHANT: "/logisticservice/api/merchant/",
  RUNSHEET_STATUS: "/runsheetservice/api/runsheet-settings/",
  USER: "/usermanagementservice/api/user/",
  RTV_STATUS: "/projectsettingsservice/api/rtv-order-settings/",
  RTV_BRANCH_STATUS: "/projectsettingsservice/api/rtv-branch-settings/",
  STATUS_NEXT: "logisticservice/api/status/next-status/",
  RTV_ORDER: "/rtvorderservice/api/rtv-order/",
  RTV_BRANCH: "/rtvorderservice/api/rtv-branch-order/",
  RTV_BRANCH_ITEMS: "/rtvorderservice/api/rtv-branch-order-item/",
  RTV_CHARGE: "/rtvorderservice/api/rtv-charge-settings/",
  RTV_ORDER_ITEMS: "/rtvorderservice/api/rtv-order-item/",
};

export default APIS;
